// 滑动切换——主流程
const MainRoutes = Array.from({ length: 6 }, (_, i) => ({
  path: `module/sliderSwitch/index${i + 1}`,
  name: `module/sliderSwitchIndex${i + 1}`,
  component: () => import(`@/views/recognize/module/sliderSwitch/index${i + 1}.vue`)
}))

export default {
  path: '/recognize',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    // 滑动切换——主流程，开始
    ...MainRoutes
  ]
}
